export function prepareJsonString(str: string): string {
    const strParts = (str || '').split(',');
    let result = '';

    for (let i = 0; i < strParts.length; i++) {
        result += strParts[i].trim() !== '}' ? (strParts[i] + ((i !== strParts.length - 1 && strParts[i + 1] !== '}') ? ',' : '')) : '}';
    }

    return result.replace(/({|,)(?:\s*)(?:')?([A-Za-z_$\.][A-Za-z0-9_ \-\.$]*)(?:')?(?:\s*):/g, "$1\"$2\":");
}